import ProjectsBudgetAverage from "./statistics/ProjectsBudgetAverage";
import ProjectsTimeAverage from "./statistics/ProjectsTimeAverage";
import LastTwelvesMonthsProjects from "./statistics/LastTwelvesMonthsProjects";
import React from "react";
import styled from "styled-components";

const Statistics = ({ projects }) => {
  return (
    <StatContainer
    >
      <ProjectsBudgetAverage selectedProjects={projects} />

      <ProjectsTimeAverage selectedProjects={projects} />

      <LastTwelvesMonthsProjects selectedProjects={projects} />
    </StatContainer>
  );
};

const StatContainer = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  align-items: center;
  page-break-after: always;
  gap: 2rem;
  width: 100%;
  padding: 1rem;
  margin: 0;
`

export default Statistics;
